<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    :class="$vuetify.breakpoint.mobile ? 'mt-4' : 'mt-2'"
    entity-name="pay"
    :model="model"
    icon="mdi-cash-plus"
  />
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Payment from '@/model/dataLayer/api/common/Payment'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Payment
    })
  }
}
</script>
